import React, { useState } from 'react';
import './about.css';
import Business from '../../assets/business-design.png';
import WebDesign from '../../assets/website-design.png';
import BackDesign from '../../assets/backend-design.png';

const About = () => {
  const [visibleSection, setVisibleSection] = useState(null);

  const toggleVisibility = (section) => {
    setVisibleSection(visibleSection === section ? null : section);
  };

  return (
    <section id='about'>
      <span className='aboutTitle'>What I Do</span>
      <span className='aboutDesc'>
        I'm a passionate junior web designer with a background in business management. I have a strong understanding of design and a keen eye for detail. Due to my professional experience in business, I have developed a stack of soft skills like teamwork, communication, leadership, and time management.
      </span>
      <div className='aboutBars'>
        <div className={`aboutBar ${visibleSection === 'frontend' ? 'expanded' : ''}`}>
          <h2 onClick={() => toggleVisibility('frontend')}>
            Frontend Developer <span className="toggle-icon">{visibleSection === 'frontend' ? '▲' : '▼'}</span>
          </h2>
          {visibleSection === 'frontend' && (
            <div className='aboutContent'>
              <img src={WebDesign} alt='Web Design' className='aboutBarImg' />
              <p>
                As a recent graduate from a comprehensive coding course, I have honed my skills in creating dynamic and responsive web applications. My training included practical projects that allowed me to apply best practices in coding, debugging, and deploying web applications. I also have basic knowledge of using Postman for API testing and documentation, ensuring that the frontend components I develop are well-integrated with backend services.
              </p>
            </div>
          )}
        </div>
        <div className={`aboutBar ${visibleSection === 'backend' ? 'expanded' : ''}`}>
          <h2 onClick={() => toggleVisibility('backend')}>
            Backend Developer <span className="toggle-icon">{visibleSection === 'backend' ? '▲' : '▼'}</span>
          </h2>
          {visibleSection === 'backend' && (
            <div className='aboutContent'>
              <img src={BackDesign} alt='Back Design' className='aboutBarImg' />
              <p>
                My course experience provided me with the foundations in Node.js and Express, enabling me to develop basic but scalable server-side applications. I know how to create and manage APIs and basic experience with MongoDB for designing, implementing, and managing databases. Furthermore, I am capable of developing controllers and routes to handle requests efficiently, maintaining clean and organized code that follows industry standards.
              </p>
              </div>
          )}
        </div>
        <div className={`aboutBar ${visibleSection === 'business' ? 'expanded' : ''}`}>
          <h2 onClick={() => toggleVisibility('business')}>
            Business Manager <span className="toggle-icon">{visibleSection === 'business' ? '▲' : '▼'}</span>
          </h2>
          {visibleSection === 'business' && (
             <div className='aboutContent'>
              <img src={Business} alt='Business' className='aboutBarImg' />
              <p>
                As a Bachelor of Business Administration, I bring over a decade of progressive experience in key financial, administrative, and management roles within dynamic business environments. My career journey has equipped me with a robust skill set and a comprehensive understanding of business operations, financial management, and strategic planning.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default About;
